import { styled, css } from 'styled-components';
import { colors } from '../../../../abstracts';
import { createGridContainer, dontForwardProps } from '../../../../util';
import { StyledHeader, StyledFooter } from '../../common';
import { StyledListItem } from './styledListItem';
import { StyledUnorderedList } from './styledUnorderedList';
const StyledList = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1ltn4c3-0"
})(["", ";", ";", ";", "{flex-direction:column;", ";}"], ({
  isCard
}) => isCard && css(["background:", ";box-shadow:0 0.25rem 1.875rem rgba(0,0,0,0.2);border-radius:0.5rem;padding-top:1.5rem;", ",", "{padding-left:1rem;padding-right:1rem;}", "{padding-left:1rem;padding-right:1rem;}"], colors.white, StyledHeader, StyledFooter, StyledListItem), ({
  isSpacingCompact,
  isHorizontal
}) => {
  const spacing = isSpacingCompact ? `0.75rem` : `1.5rem`;
  const padding = isSpacingCompact ? 0.75 : 1.5;
  const footerPadding = padding / 2;
  return css(["", ",", "{padding-bottom:", ";}", "{padding-top:", "rem;}", "{padding-bottom:", ";}"], StyledHeader, StyledFooter, spacing, StyledFooter, footerPadding, StyledListItem, isHorizontal ? 0 : spacing);
}, ({
  isSpacingCompact
}) => {
  const paddingTop = isSpacingCompact ? `0.75rem` : `1.5rem`;
  return css(["", "{padding-top:", ";}"], StyledUnorderedList, paddingTop);
}, StyledUnorderedList, ({
  isCard,
  isHorizontal,
  maxItemsPerRow,
  isSpacingCompact
}) => {
  const spacing = isSpacingCompact ? `0.75rem` : `1.5rem`;
  const horizontalListPadding = isCard ? `1rem` : 0;
  return isHorizontal && css(["", ";padding-left:", ";padding-right:", ";justify-content:flex-start;", "{padding-left:0;padding-right:0;}"], createGridContainer(spacing, maxItemsPerRow, '13.25rem'), horizontalListPadding, horizontalListPadding, StyledListItem);
});
export { StyledList };